/**
 * Cheat-sheet dialog that lists every global keyboard shortcut.
 * Triggered via `?` from any view; closed via Esc or scrim click
 * (Radix handles both).
 *
 * Reference: spec section 15.5 and 7.7.
 */

import * as Dialog from '@radix-ui/react-dialog';

import { useCheatSheet, SHORTCUTS } from '@/lib/keyboard-shortcuts';

export function CheatSheet() {
  const isOpen = useCheatSheet((s) => s.isOpen);
  const close = useCheatSheet((s) => s.close);

  return (
    <Dialog.Root open={isOpen} onOpenChange={(next) => (next ? null : close())}>
      <Dialog.Portal>
        <Dialog.Overlay
          aria-hidden
          className="fixed inset-0 z-40 bg-black/55 data-[state=open]:animate-in"
        />
        <Dialog.Content
          aria-label="Keyboard shortcuts"
          className="fixed left-1/2 top-1/2 z-50 w-[420px] max-w-[calc(100vw-2rem)] -translate-x-1/2 -translate-y-1/2 border border-mx-grey-800 bg-mx-card p-mx-5 text-mx-white"
        >
          <Dialog.Title className="font-display text-mx-h2 font-semibold">
            Keyboard shortcuts
          </Dialog.Title>
          <Dialog.Description className="sr-only">
            Global keyboard bindings. Esc to close.
          </Dialog.Description>
          <ul className="mt-mx-4 flex flex-col gap-mx-2">
            {SHORTCUTS.map((entry) => (
              <li
                key={entry.key}
                className="flex items-center justify-between border-b border-mx-grey-800 pb-mx-2"
              >
                <span className="text-mx-body-sm text-mx-grey-300">{entry.description}</span>
                <span className="mono-label bg-mx-grey-800 px-mx-2 py-[2px] text-mx-mono text-mx-white">
                  {entry.key}
                </span>
              </li>
            ))}
          </ul>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
